<template>
  <div class="p1">
    <div class="flex-row m1 start top list border-end p1">
      <img src="/static/icon/tiku.png" alt="" style="width: 120px; height: 80px" />
      <div class="flex-column">
        <div class="flex-row f20b">{{ value.Name }}</div>
        <div class="flex-row f16g mt20">{{ value.CreateTime }}</div>
      </div>
    </div>

    <mx-page type="Home" theme="Panel" :config="config" :name="config.Title + '顶部统计'" :title="config.Title + '顶部统计'" @event="OnEvent" :query="Query" v-if="config.Title + '顶部统计'" :key="config.Title + '顶部统计'"> </mx-page>
    <mx-page
      type="Home"
      theme="Panel"
      :config="config"
      :parent="value"
      :parent-type="config.Type"
      :name="config.Title + '题目列表'"
      :title="config.Title + '题目列表'"
      @event="OnEvent"
      :query="Query"
      v-if="config.Title + '题目列表'"
      :key="config.Title + '题目列表' + key"
    >
    </mx-page>
  </div>
</template>
<script>
export default {
  props: {
    config: Object,
    value: Object
  },
  data() {
    return {
      key: new Date().getTime(),
      Query: {}
    }
  },
  methods: {
    OnEvent(e) {
      if (e && e.config.ColumnConfig) {
        let ColumnConfig = e.config.ColumnConfig
        this.Query = Object.assign(this.Query, { '*': { ModuleType: ColumnConfig.ModuleType } })
        this.key = new Date().getTime()
      }
    }
  }
}
</script>
<style scoped>
.mt20 {
  margin-top: 20px;
}
</style>
